import { Container, HeadingContainer, Heading, Actions } from './styled.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { GridContainer } from '../../foundation/Grid/styled.js';
import { H1 } from '../../foundation/Typography/styled.js';

function PageHeader(props) {
  var actions = props.actions,
    breadcrumbs = props.breadcrumbs,
    heading = props.heading,
    chip = props.chip,
    tabs = props.tabs;
  return /*#__PURE__*/jsx(Container, {
    children: /*#__PURE__*/jsxs(GridContainer, {
      children: [breadcrumbs, /*#__PURE__*/jsxs(HeadingContainer, {
        children: [/*#__PURE__*/jsxs(Heading, {
          children: [/*#__PURE__*/jsx(H1, {
            children: heading
          }), chip]
        }), actions && /*#__PURE__*/jsx(Actions, {
          children: actions
        })]
      }), tabs]
    })
  });
}

export { PageHeader };
